module.exports = __webpack_public_path__ + "static/media/banner.b4594f6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sponsors/yanolja/banner.png
// module id = 91
// module chunks = 0